export default {
    setDeliveries(state, payload) {
        state.deliveries = payload
    },
    setAllDeliveries(state, payload) {
        state.allDeliveries = payload
    },
    setPendingSelfCollection(state, payload) {
        state.pendingSelfCollection = payload
    },
    setNotDeliveredDeliveries(state, payload) {
        state.notDeliveredDeliveries = payload
    },
    setDeliveryBagsCount(state, payload) {
        state.deliveryBagsCount = payload
    },
    setDelivery(state, payload) {
        state.delivery = payload
    },
    setSearchHistoricalDeliveries(state, payload) {
        state.searchHistoricalDeliveries = payload
    },
    setTotalDeliveriesToGenerate(state, payload) {
        state.totalDeliveriesToGenerate = payload
    },
    setDeliveriesGeneratedCount(state, payload) {
        state.deliveriesGeneratedCount = payload
    },
    setDeliveryStats(state, payload) {
        state.deliveryStats = payload
    },
    setDeliveryStatsLoading(state, payload) {
        state.deliveryStatsLoading = payload
    },
    setStatsRefreshCooldownUntil(state, payload) {
        state.statsRefreshCooldownUntil = payload
    }
}